export default "__VITE_PUBLIC_ASSET__762f6a0c__"